import { HttpClient } from '@angular/common/http';
import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from 'app/dialogs/confirm-dialog/confirm-dialog.component';
import { ControllerType, HttpClientService } from 'app/services/http-client.service';
import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[appDelete]'
})
export class DeleteDirective {
  @Input() controller!: any;
  @Input() action!: string;
  @Input() id!: number;
  @Output() callback:EventEmitter<any>=new EventEmitter();
  @Input() message? = "Bu kaydı silmek istediğinizden emin misiniz?";
  constructor(private httpclientService: HttpClientService, private modalService: NgbModal, private router: Router,private toastService:ToastrService) { }

  // Tıklama dinleyicisi
  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.preventDefault();

    // Onay diyaloğunu aç
    const modalRef = this.modalService.open(ConfirmDialogComponent,{
      windowClass: 'modal modal-danger'
    });
    modalRef.componentInstance.data = {
      message:this.message,
      title : "Silme Uyarısı!!!"
    };

    // Diyalog kapanınca sonucu kontrol et
    modalRef.result.then((result) => {
      if (result) {
        // Eğer 'Evet' tıklandıysa silme işlemi yap
        this.deleteItem();
      }
    }).catch((err) => {
      console.log('Diyalog kapatıldı:', err);
    });
  }

  // Silme işlemi
  private deleteItem() {
    this.httpclientService.delete({
      controller:this.controller,
      action:this.action
    },this.id).subscribe({
      next: () => {
        this.toastService.success("Başarılı bir şekilde silindi.");
        this.callback.emit();
      },
      error: (err) => {
        this.toastService.error("Silinirken bir problem oluştu.");
      }
    });
  }
}